import PropTypes from 'prop-types';

import Grid from '@zenbusiness/zui/Grid';

import InfoItem from './InfoItem';

function InfoSection({ infos }) {
  return (
    <Grid container rowSpacing={3} columnSpacing={{ xs: 2, md: 4 }}>
      {infos.map(({ title, items }) => (
        <Grid item xs={12} md={6} key={title}>
          <InfoItem title={title} items={items} />
        </Grid>
      ))}
    </Grid>
  );
}

InfoSection.propTypes = {
  infos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        }),
      ),
    }),
  ).isRequired,
};

export default InfoSection;
